import styled, { css } from 'styled-components';
import { padding, PaddingBottomProps, variant } from 'styled-system';
import ThemeUtilities from '../../../theme/ThemeUtilities';
import { ComponentVariants } from '../CreditCardNumber/type';

export const Header = styled.div<
  PaddingBottomProps & {
    variant?: ComponentVariants;
  }
>`
  ${({ theme }) => css`
    gap: ${theme.space[3]}px;
  `};

  display: inline-flex;
  align-items: center;
  cursor: pointer;

  ${padding};
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Accordion', 'variant'))};
`;

export const IconWrapper = styled.div<{ isExpanded: boolean }>`
  will-change: transform;
  transform: ${(props) =>
    props.isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)'};
  transition: 150ms transform ease-in-out;
`;

Header.defaultProps = {
  variant: 'regular',
};
